import { useQuery } from '@tanstack/react-query';
import type { LeadDTO } from '@bifeai/shared';
import { Card, CardBody, CardHeader, EmptyState, PageHeader } from '@bifeai/ui';
import { Inbox } from 'lucide-react';
import { api } from '../lib/api';
import { formatDateTime } from '../lib/format';

/** Consultas que llegan desde el formulario de bifeai.com. */
export function LeadsPage() {
  const leads = useQuery({ queryKey: ['billing', 'leads'], queryFn: () => api.get<LeadDTO[]>('/platform/billing/leads') });
  return (
    <>
      <PageHeader title="Consultas" subtitle="Las que dejan en bifeai.com. También llegan a ventas@bifeai.com." />
      <Card>
        <CardHeader title="Consultas de la web" subtitle="Las del formulario de bifeai.com (también llegan a ventas@bifeai.com)." />
        <CardBody flush>
          {!leads.data?.length ? (
            <EmptyState icon={<Inbox />} title="Sin consultas" />
          ) : (
            <div className="bf-table-wrap">
              <table className="bf-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Quién</th>
                    <th>Consulta por</th>
                    <th>WhatsApp</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.data.map((l) => (
                    <tr key={l.id}>
                      <td className="bf-cell-sub">{formatDateTime(l.createdAt)}</td>
                      <td>
                        <span className="bf-cell-main">{l.business}</span>
                        <div className="bf-cell-sub">{[l.name, l.locations, l.country].filter(Boolean).join(' · ')}</div>
                      </td>
                      <td>{l.interest ?? 'Demo'}</td>
                      <td>
                        <a href={`https://wa.me/${l.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer">
                          {l.whatsapp}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
}
